// extracted by mini-css-extract-plugin
export default {"palletsAmount":"PalletTotalAmountInfo_palletsAmount__3NQlO"};